export const validateMinMax = (value, min, max) => {
  let isValidated = true;

  const valueLength = value?.trim().length;

  if (min) {
    isValidated = valueLength >= min;
  }

  if (max) {
    isValidated = valueLength <= min;
  }

  return isValidated;
};

export const validateJson = (text) => {
  if (typeof text !== 'string') {
    return false;
  }
  try {
    const json = JSON.parse(text);
    return typeof json === 'object';
  } catch (error) {
    return false;
  }
};

/**
 * Validates if a given number contains exactly 10 digits.
 * No alphabets or symbols are allowed.
 *
 * @param {string | number} number - The number to validate.
 * @returns {boolean} - Returns true if the number has exactly 10 digits, otherwise false.
 */
export function isValidIndianNumber(number) {
  // Convert number to string to handle both number and string inputs
  const numStr = number.toString();

  // Regular expression to match exactly 10 digits
  const tenDigitRegex = /^\d{10}$/;

  return tenDigitRegex.test(numStr);
}
